export type Bounds = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export type LockedDimension = 'width' | 'height';

export type ColorSizeMetrics = {
  squareMeter: number;
  /** Rounded linear meters used for laser / milling surcharge pricing. */
  perimeter: number;
  /** Exact calculated linear meters before billing rounding. */
  measuredPerimeter: number;
};

export type MeasurementsByColor = Record<string, ColorSizeMetrics>;

export type ColorArea = {
  color: string;
  colorOptionId: string;
};

export type ColorAreaBounds = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export type TextItem = {
  type: 'text';
  id: string;
  content: string;
  fontFamily: string;
  color: string;
  colorOptionId?: string;
  selectedOptions?: Record<string, string>;
  x: number;
  y: number;
  width: number;
  height: number;
  baseWidth: number;
  baseHeight: number;
  trimViewBoxX?: number;
  trimViewBoxY?: number;
  viewBoxWidth: number;
  viewBoxHeight: number;
  scale: number;
  lockedDimension: LockedDimension;
  pathData?: string;
  pathOffsetX?: number;
  pathOffsetY?: number;
  sourcePerimeter?: number;
  squareMeter?: number;
  /** Exact cut length in meters at the current display size. */
  measuredPerimeter?: number;
  /** Rounded cut length in meters for pricing (Math.round of measuredPerimeter). */
  perimeter?: number;
};

export type ImageItem = {
  type: 'image';
  id: string;
  url: string;
  svgSource?: string;
  imageData?: Record<string, unknown>;
  colorAreas?: ColorArea[];
  initialColorAreas?: ColorArea[];
  colorAreaBounds?: ColorAreaBounds[];
  selectedOptions?: Record<string, string>;
  x: number;
  y: number;
  width: number;
  height: number;
  baseWidth: number;
  baseHeight: number;
  trimViewBoxX?: number;
  trimViewBoxY?: number;
  viewBoxWidth: number;
  viewBoxHeight: number;
  scale: number;
  lockedDimension: LockedDimension;
  sourcePerimeter?: number;
  squareMeter?: number;
  /** Exact cut length in meters at the current display size. */
  measuredPerimeter?: number;
  /** Rounded cut length in meters for pricing (Math.round of measuredPerimeter). */
  perimeter?: number;
};

export type EditorItem = TextItem | ImageItem;

export type EditorState = {
  objects: Record<string, EditorItem>;
  selectedId: string | null;
  designSize: Bounds;
  addMode: 'text' | 'image' | null;
};

export const emptyBounds = (): Bounds => ({
  x: 0,
  y: 0,
  width: 0,
  height: 0,
});

export const createInitialEditorState = (): EditorState => ({
  objects: {},
  selectedId: null,
  designSize: emptyBounds(),
  addMode: null,
});
